import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { PropType } from 'vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import { dnsServers } from '@/common/dnsServers';
import { ApiErrorType } from '@/model/ApiErrorAlert';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApiErrorAlert',
  props: {
  error: {
    type: String as PropType<ApiErrorType>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
  dnsserver: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Alert, { type: "warning" }, {
    default: _withCtx(() => [
      (__props.error === 'HasNoReverseDnsRecord')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[0] || (_cache[0] = _createTextVNode(" IP addresses can't have any DNS records attached to them. We tried to find the hostname of this IP address with a reverse DNS lookup, and show the DNS records for that instead. However, the IP address ", -1)),
            _createElementVNode("b", null, _toDisplayString(__props.domain), 1),
            _cache[1] || (_cache[1] = _createTextVNode(" has no reverse DNS record. ", -1))
          ], 64))
        : (__props.error === 'InvalidDomain')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("b", null, _toDisplayString(__props.domain), 1),
              _cache[2] || (_cache[2] = _createTextVNode(" is not a valid domain name. For example, try ", -1)),
              _createVNode(DnsRecordsLink, {
                domain: "wikipedia.org",
                class: "font-semibold hover:underline"
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" or ", -1)),
              _createVNode(DnsRecordsLink, {
                domain: "www.twitter.com",
                class: "font-semibold hover:underline"
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" to view their DNS records. ", -1))
            ], 64))
          : (__props.error === 'DnsQueryFailed')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[5] || (_cache[5] = _createTextVNode(" One or more DNS queries failed while looking up DNS records for ", -1)),
                _createElementVNode("b", null, _toDisplayString(__props.domain), 1),
                _cache[6] || (_cache[6] = _createTextVNode(". Please try again. ", -1))
              ], 64))
            : (__props.error === 'NoDnsServersAvailable')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_unref(dnsServers)[__props.dnsserver].type === 'local')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "None of the DNS server in " + _toDisplayString(_unref(dnsServers)[__props.dnsserver].pretty) + " are available. Please try again another DNS server by selecting it above.", 1))
                    : (_unref(dnsServers)[__props.dnsserver].type === 'popular')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "None of the " + _toDisplayString(_unref(dnsServers)[__props.dnsserver].pretty) + " DNS servers are available. Please try again another DNS server by selecting it above.", 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_3, "None of the authoritative DNS servers are available. Please try again another DNS server by selecting it above."))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Nslookup was unable to find DNS records for ", -1)),
                  _createElementVNode("b", null, _toDisplayString(__props.domain), 1),
                  _cache[8] || (_cache[8] = _createTextVNode(". ", -1))
                ], 64))
    ]),
    _: 1
  }))
}
}

})